import { BackendErrorCode, type BackendErrorEntity, type ErrorType } from '~/apiClient';
import type { PlatformSaleItemEntity } from '~/types/sale.type';

export type UseSdpParamsCheckerReturnType = void;

export const useSdpParamsChecker = (
    sale: Ref<PlatformSaleItemEntity | undefined>,
    error: Ref<ErrorType<BackendErrorEntity> | null>,
    isError: Ref<boolean>
): UseSdpParamsCheckerReturnType => {
    const { id, slug } = useSdpParams();
    const route = useRoute();
    const routeBaseName = useRouteBaseName();

    if (sale.value && isSdpRoute(routeBaseName(route)) && slug.value !== sale.value.slug && slug.value.endsWith(sale.value.id)) {
        // Redirect to correct slug
        navigateTo({ name: route.name, params: { slug: sale.value.slug } });
    } else if (
        !id.value ||
        error.value?.data?.error.code === BackendErrorCode.EntityNotFound || // backend 404
        error.value?.data?.error.code === BackendErrorCode.InvalidUUID || // backend 400
        slug.value !== sale.value?.slug // Slug is not correct
    ) {
        showError({ status: 404 });
    } else if (isError.value) {
        // Backend 500
        showError({ status: 500 });
    }
};
